import React, { useEffect, useState } from "react";
import { AvatarIcon } from "@components/icons/common/AvatarIcon";
import { useFacebookAuth } from "@hooks/useFacebookAuth";
import { useCustomerDetailsQuery } from "@services/customer/queries";

export const CustomerAvatar: React.FC = () => {
  const [facebookAccessToken, setFacebookAccessToken] = useState<
    string | undefined
  >();

  const { data } = useCustomerDetailsQuery();
  const { getFacebookAccessToken } = useFacebookAuth();

  useEffect(() => {
    void (async () => {
      if (data?.facebookUserId) {
        const response = await getFacebookAccessToken();

        if (response) {
          setFacebookAccessToken(response);
        }
      }
    })();
  }, [data?.facebookUserId, getFacebookAccessToken]);

  const avatarUrl = facebookAccessToken
    ? `https://graph.facebook.com/${data?.facebookUserId}/picture?type=large&access_token=${facebookAccessToken}`
    : undefined;

  return (
    <React.Fragment>
      {avatarUrl ? (
        <img
          className="h-10 w-10 rounded-full"
          src={avatarUrl}
          alt={`${data?.firstName} ${data?.lastName}`}
        ></img>
      ) : (
        <AvatarIcon className="relative inline-flex h-10 w-10 items-center justify-center rounded-full border border-grey-hover" />
      )}
    </React.Fragment>
  );
};
